import { useEffect } from 'react';

import { IS_PRODUCTION } from '@/common/constants';

// Track last error to prevent infinite reset loops
let lastErrorKey: string | null = null;
let resetCount = 0;

/**
 * Auto-resets error boundary once in development for HMR recovery.
 * Prevents infinite loops by tracking error messages.
 */
export function useDevErrorReset(error: Error, reset: () => void) {
  useEffect(() => {
    if (IS_PRODUCTION) return;

    const errorKey = error?.message ?? 'unknown';

    if (errorKey !== lastErrorKey) {
      lastErrorKey = errorKey;
      resetCount = 0;
    }

    if (resetCount > 0) return;
    resetCount++;

    const timer = setTimeout(reset, 100);
    return () => clearTimeout(timer);
  }, [error, reset]);
}
